import { useRef, useState } from "react";
import api, { BACKEND_URL } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Loader2, Upload, X, Link2 } from "lucide-react";

// value stored is a full URL (uploaded file or pasted link)
export default function MediaUpload({ label, accept, value, onChange, testid }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 50 * 1024 * 1024) { toast.error("Arquivo excede 50MB"); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${BACKEND_URL}${data.url}`);
      toast.success("Arquivo enviado");
    } catch {
      toast.error("Falha no upload");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <div className="mt-1 flex items-center gap-2">
        <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
        <Button type="button" variant="outline" size="sm" className="rounded-full" onClick={() => inputRef.current?.click()} disabled={uploading} data-testid={`${testid}-btn`}>
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Upload className="w-4 h-4 mr-1" />Enviar</>}
        </Button>
        {value ? (
          <div className="flex items-center gap-1 text-xs text-accent min-w-0">
            <Link2 className="w-3.5 h-3.5 shrink-0" />
            <span className="truncate max-w-[140px]">enviado</span>
            <button type="button" onClick={() => onChange("")} className="text-destructive"><X className="w-3.5 h-3.5" /></button>
          </div>
        ) : <span className="text-xs text-muted-foreground">ou cole um link abaixo</span>}
      </div>
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="https://"
        className="mt-1.5 w-full h-9 rounded-lg border border-input bg-background px-3 text-sm" data-testid={`${testid}-url`} />
    </div>
  );
}
